import { classnames } from '@okee-uikit/react-utils';
import { useConfig } from './useConfig';
export function usePrefixCls(className, suffixClass, ignoreRootCls) {
  var _useConfig = useConfig(),
      prefixCls = _useConfig.prefixCls;

  return getPrefixCls(prefixCls + '-' + className, suffixClass, ignoreRootCls);
}
export function getPrefixCls(mainClassName, suffixClass, ignoreRootCls) {
  var suffixClassNames = [];

  if (suffixClass) {
    Object.keys(suffixClass).forEach(function (key) {
      var value = suffixClass[key];

      if (value === false || value == null || value === '') {
        return;
      }

      var suffix = typeof value === 'string' || typeof value === 'number' ? "-".concat(value) : '';
      suffixClassNames.push(mainClassName + '-' + key + suffix);
    });
  }

  return classnames(ignoreRootCls ? undefined : mainClassName, suffixClassNames);
}